import { apiClient } from './client';

export interface SearchItem {
  id: number;
  title: string | null;
  subtitle: string | null;
  /** Готовый маршрут внутри админки — куда вести по клику. */
  url: string;
}

export interface SearchGroup {
  key: string;
  title: string;
  items: SearchItem[];
}

export interface SearchResults {
  query: string;
  /** Пустые группы сюда не попадают. */
  groups: SearchGroup[];
}

export async function search(query: string): Promise<SearchResults> {
  const { data } = await apiClient.get<SearchResults>('/search', { params: { q: query } });
  return data;
}
